import { SVGProps } from "react";

import { ApplyViaOtta } from "@otta/search/components/Icons/ApplyViaOtta";
import { CalendarClock } from "@otta/search/components/Icons/CalendarClock";
import { FullyRemote } from "@otta/search/components/Icons/FullyRemote";
import { HandsHoldingHeart } from "@otta/search/components/Icons/HandsHoldingHeart";
import { MoneyBillWave } from "@otta/search/components/Icons/MoneyBillWave";
import { Salary } from "@otta/search/components/Icons/Salary";
import { Sector } from "@otta/search/components/Icons/Sector";
import { Technologies } from "@otta/search/components/Icons/Technologies";
import { Venn } from "@otta/search/components/Icons/Venn";
import { Venus } from "@otta/search/components/Icons/Venus";
import { VisibleEye } from "@otta/search/components/Icons/VisibleEye";
import { ThemeId } from "@otta/search/schema";

export function ThemeIcon({
  themeId,
  ...props
}: {
  themeId: ThemeId | "ALL_MATCHES";
} & SVGProps<SVGSVGElement>): React.ReactElement {
  const Icon = getIcon(themeId);
  return <Icon {...props} />;
}

const getIcon = (
  themeId: ThemeId | "ALL_MATCHES"
): React.ComponentType<SVGProps<SVGSVGElement>> => {
  switch (themeId) {
    case ThemeId.ApplyViaOtta:
      return ApplyViaOtta;
    case ThemeId.FemaleFounders:
      return Venus;
    case ThemeId.HasSalaries:
      return Salary;
    case ThemeId.PreferredSector:
      return Sector;
    case ThemeId.NewlyAdded:
      return CalendarClock;
    case ThemeId.RecentlyFunded:
      return MoneyBillWave;
    case ThemeId.TechForGood:
      return HandsHoldingHeart;
    case ThemeId.FullyRemote:
      return FullyRemote;
    case ThemeId.FavouriteTechnologies:
      return Technologies;
    case ThemeId.TakeAnotherLook:
      return VisibleEye;
    case "ALL_MATCHES":
      return Venn;
    default:
      return ApplyViaOtta;
  }
};
